<template>
  <div>
    <echarts
      :key="chartId"
      :containerId="chartId"
      :options="options"
      :refreshToken="chartId"
      type="chart_big"
    >
    </echarts>
  </div>               
</template>

<script>

// eslint-disable-next-line
import Echarts from '@/components/Echarts'
// eslint-disable-next-line
import echarts from 'echarts'
import { formatNumber } from '../utils/misc'

export default {
  name: 'SubAreaCharts',
  components: {
    Echarts
  },
  props: {
  },
   watch: {
    '$route' () {
      this.prepareData()
      this.loadGraph()
    },
    /*
    '$store.getters.show_overlay': function() {
        this.overlay = this.$store.getters.show_overlay
      },
    */
  },     
  data () {
    let chartId = 'SubAreaCharts-' + Math.random().toString(36).substring(2, 15)
    let options = []
    let countries = []
    let tlTree = {}
    let overlay = false
    return {
      chartId,
      countries,
      options,
      tlTree,
      overlay
    }
  },
  methods: {
    prepareData: function () {
      let tl = this.$store.getters.TL.replace("TL", "")
      let tlToWalk = {}
      
      if (tl === "2") {
        tlToWalk = this.$store.getters.TL2
      }
      else if (tl === "3") {
        tlToWalk = this.$store.getters.TL3
      }
      else if (tl === "FUA") {
        tlToWalk = this.$store.getters.FUA
      }
      else if (tl === "EFUA") {
        tlToWalk = this.$store.getters.EFUA
      }
      else if (tl === "CY") {
        tlToWalk = this.$store.getters.CY
      }

      let ds = this.$store.getters.ds
      let year = this.$store.getters.year.toString()

      // let ds_data = null
      let code = ''
      let name = ''
      let value = ''
      for (let t of tlToWalk) {
          if (tl === "FUA" || tl === "EFUA" || tl === "CY") {code = t.id.toString()} else {code = t.code.toString()}
          name = t.name

          if (!this.tlTree[t.country]) {
            this.tlTree[t.country] = {}
          }
          value = ds.dataset[year][code]

          if (value !== undefined) {
            this.tlTree[t.country][name] = value
          }
        }
    },

  compare: function(a, b) {
    // Use toUpperCase() to ignore character casing
    const nameA = a.name.toUpperCase()
    const nameB = b.name.toUpperCase()

    let comparison = 0
    if (nameA > nameB) {
      comparison = 1
    } else if (nameA < nameB) {
      comparison = -1
    }
    return comparison * -1
  },

  loadGraph: function () {
      let countries = []
      let n = 0 
      let nt = 0
      //var data = []

      let countryID = this.$store.getters.countryID
      var dataC = new Array()
      var dataT = new Array()

      var len = this.$store.getters.legendThresholds.length
      for ( var lt=1; lt <= len; lt++) {
          dataT.push( new Array() )
          dataC.push( new Array() )
      }

      var keys = Object.keys(this.tlTree);
      var kcs = new Array()
      for(var cc=0; cc<keys.length; ++cc){
          if (this.$store.getters.getCountryById(keys[cc])){
          let kc = {"key": keys[cc], "name": this.$store.getters.getCountryById(keys[cc]).name}
          kcs.push(kc)          
        }
      }
      kcs = kcs.sort(this.compare)
      var countryok 

      for(var i=0; i<kcs.length; ++i){
        countryok = false
        var c = kcs[i]['key']

        for (const tu in this.tlTree[c]) {
          nt = 0
          
          if (this.tlTree[c][tu]) {
            countryok = true
            for (var t = len -1; t >= 0; t--)
            {
              if (this.tlTree[c][tu] > this.$store.getters.legendThresholds[t]) {
                dataT[nt].push([this.tlTree[c][tu], n, tu]) 
                if (countryID === c){
                    dataC[nt].push([this.tlTree[c][tu], n, tu]) 
                }
                break
              }
              nt = nt + 1
            }
          }
        } 
        if (countryok) {
          if (this.$store.getters.getCountryById(c)){
            countries.push(this.$store.getters.getCountryById(c).name)
            n=n+1
          }
        }
      }



      var series = []
      len = dataT.length
      n = 0
      for (t = len -1; t >= 0; t--) {
          series.push({
            name: '',
            type: 'scatter',
            symbolSize: 10,
            data: dataT[t],
            color: this.$store.getters.legendColors[n],
            })

            series.push({
              name: '',
              type: 'scatter',
              symbolSize: 10,
              data: dataC[t],
              color:  this.$store.getters.legendColors[n],
              itemStyle: {
                borderColor:'rgb(0, 0, 0)'
              },
              })            
        n=n+1
      }

    let option = {
        title: {
            //text: this.$store.getters.indicatorTitle,
        },
        tooltip: {
            position: 'top',
            formatter: function (params) {
                return params.value[2] + ' - ' + countries[params.value[1]] + ' - ' + formatNumber(params.value[0]);
            }
        },

        dataZoom: [ 
        {
            type: 'slider',
            xAxisIndex: 0,
        },
        {
            type: 'slider',
            yAxisIndex: 0,
            startValue: 0,
            endValue: 30
        },          
],

        grid: {
            left: 2,
            bottom: 40,
            right: 10,
            containLabel: true,
            bordercolor: 'rgb(255, 0, 0)'
        },
        xAxis: {
            type: 'value',
            splitNumber: 5,
            scale: true
        },
        yAxis: {
            type: 'category',
            data: countries,
            min: 0,
            max: countries.length-1,
            splitNumber: countries.length-1,
            
            splitLine: {
                lineStyle: {
                    type: 'dashed'
                }
              },            
            axisLine: {
                show: true
            },
            axisLabel: {
                interval: 0,
                rotate: 0 
            },                    
            },
        series: series,
    }

    this.options = option
   }
   },

  beforeDestroy () {  
    this.$root.$off('component_refresh', () => {})
  },
  mounted () {
    this.$root.$on('component_refresh', () => {
      this.prepareData()
      this.loadGraph()
    }),
    this.prepareData()
    this.loadGraph()
  }
}
</script>

<style lang="scss" scoped>

</style>
